import { FindReferenceColorsFilterOptionsOutput } from '../../../services/modules/filterOptions/filterOptions.types';
import { OfflineDatabaseReferenceColor } from '../database/offlineDatabase/types/offlineDatabaseReferenceColor.types';

export class OfflineReferenceColorTransformers {
  static toFilterOptionsReferenceColor(
    data: OfflineDatabaseReferenceColor,
  ): FindReferenceColorsFilterOptionsOutput['data'][0] {
    return {
      id: data.id,
      name: data.name,
    };
  }
}
